<div class="layout" [class.layout--sidebar-collapsed]="sidebarCollapsed">
  <app-header
    [menuOpen]="menuOpen"
    (menuToggle)="toggleMenu()"
    (logout)="onLogout()"
  ></app-header>

  <div class="layout__body">
    <aside
      class="sidebar"
      [class.sidebar--open]="menuOpen"
      [attr.aria-hidden]="sidebarCollapsed ? 'true' : null"
    >
      <nav class="sidebar__nav" aria-label="Navegación principal">
        @for (item of dynamicMenu(); track item.label) {
          @if (!item.isSection) {
            <a
              [routerLink]="item.routerLink"
              routerLinkActive="is-active"
              [routerLinkActiveOptions]="{ exact: item.exact || false }"
              (click)="closeMenuOnMobile()"
            >
              <i [class]="item.icon" aria-hidden="true"></i>
              <span>{{ item.label }}</span>
            </a>
          }

          @if (item.isSection) {
            <button type="button" class="sidebar__section" (click)="toggleAdmin()">
              <span class="sidebar__section-title">
                <i [class]="item.icon" aria-hidden="true"></i>
                <span>{{ item.label }}</span>
              </span>
              <i
                class="fa-solid"
                [class.fa-chevron-down]="adminOpen"
                [class.fa-chevron-right]="!adminOpen"
                aria-hidden="true"
              ></i>
            </button>

            @if (adminOpen) {
              @for (subItem of item.subItems; track subItem.label) {
                <a
                  class="sidebar__subitem"
                  [routerLink]="subItem.routerLink"
                  routerLinkActive="is-active"
                  [routerLinkActiveOptions]="{ exact: subItem.exact || false }"
                  (click)="closeMenuOnMobile()"
                >
                  <i [class]="subItem.icon" aria-hidden="true"></i>
                  <span>{{ subItem.label }}</span>
                </a>
              }
            }
          }
        }
      </nav>

      <section class="sidebar__account" aria-label="Sesion actual">
        <div class="sidebar__account-icon">
          <i class="fa-solid fa-user" aria-hidden="true"></i>
        </div>

        <div class="sidebar__account-info">
          <strong>{{ sidebarUserName() }}</strong>
          <span>{{ sidebarUserRole() }}</span>
        </div>

        <button
          type="button"
          class="sidebar__logout"
          [disabled]="isLoggingOut"
          (click)="onLogout()"
          aria-label="Cerrar sesión"
          title="Cerrar sesión"
        >
          <i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i>
          <span>Cerrar sesión</span>
        </button>
      </section>
    </aside>

    <main class="content" (click)="closeMenuOnMobile()">
      <router-outlet></router-outlet>
    </main>
  </div>

  <app-footer></app-footer>
</div>
